import React, { useState } from 'react';
import PendingTradeCardContent from '../PendingTradeCardContent';
import PendingDecisionFooter from '../PendingTradeCardContent/PendingDecisionFooter';
import PendingListCardVariant from '../../../_shared/constants/pendingListCardVariant';
import { TradeCard } from '../PendingNegotiationCard/Styles';

const PendingDecisionCard = ({
  id,
  testId,
  tradeSummary,
  tradeContext,
  isOmp = false,
  handleNavigateToTradeUri
}) => {
  const { tradeState } = tradeSummary;
  const [isAuctionEnded, setIsAuctionEnded] = useState(tradeSummary.isGreyOut);

  return (
    <TradeCard id={id} testId={testId}>
      <PendingTradeCardContent
        testId={testId}
        tradeSummary={tradeSummary}
        tradeState={tradeState}
        tradeContext={tradeContext}
        listCardVariant={PendingListCardVariant.DECISION}
        onAuctionEnded={() => {
          setIsAuctionEnded(true);
        }}
        isOmp={isOmp}
        handleNavigateToTradeUri={handleNavigateToTradeUri}
      />
      <PendingDecisionFooter
        testId={`${testId}-footer`}
        tradeSummary={tradeSummary}
        tradeContext={tradeContext}
        disableActionButtons={isAuctionEnded}
        isOmp={isOmp}
        handleNavigateToTradeUri={handleNavigateToTradeUri}
      />
    </TradeCard>
  );
};

export default PendingDecisionCard;
